import { isDarkTheme } from '@skbkontur/react-ui/lib/theming/ThemeHelpers';
import { isFunction } from '@skbkontur/react-ui/lib/utils';
import { memo } from '../utils/memo';
import { AddonsThemeInternal, isAddonsTheme, markAsAddonsTheme } from '../../internal/themes/AddonsTheme';
import { AddonsThemeDarkInternal } from '../../internal/themes/AddonsDarkTheme';
/**
 * Creates AddonsTheme out of ReactUI's Theme.
 *
 * Inserts Addons vars in the theme, puts them over ReactUI's vars,
 * but respects these Addons vars values that might have been specified in ReactUI's theme before that.
 *
 * This allows inserting Addons vars in the theme on the fly
 * (without need for users to do it manually in their apps),
 * and using ReactUI's ThemeContext.Provider for overriding them.
 */
export var createAddonsTheme = function (theme) {
    if (isAddonsTheme(theme))
        return theme;
    var addonsTheme = Object.create(theme, Object.assign(Object.getOwnPropertyDescriptors(AddonsThemeInternal), isDarkTheme(theme) ? Object.getOwnPropertyDescriptors(AddonsThemeDarkInternal) : {}));
    var _loop_1 = function (key) {
        var descriptor = Object.getOwnPropertyDescriptor(addonsTheme, key);
        Object.defineProperty(addonsTheme, key, {
            get: function () {
                if (descriptor) {
                    var get = descriptor.get, value = descriptor.value;
                    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
                    // @ts-ignore
                    return theme[key] || (isFunction(get) ? get.call(this) : value);
                }
            },
        });
    };
    for (var _i = 0, _a = Object.keys(addonsTheme); _i < _a.length; _i++) {
        var key = _a[_i];
        _loop_1(key);
    }
    return markAsAddonsTheme(addonsTheme);
};
export var getAddonsTheme = memo(function (theme) {
    return createAddonsTheme(theme);
});
function isZeroArgs(fn) {
    return fn.length == 0;
}
var memoize = function (fn) {
    if (isZeroArgs(fn)) {
        var isCalled_1 = false;
        var result_1;
        return function () {
            if (!isCalled_1) {
                isCalled_1 = true;
                result_1 = fn();
            }
            return result_1;
        };
    }
    var cache = new WeakMap();
    return function (arg) {
        if (!cache.has(arg))
            cache.set(arg, fn(arg));
        return cache.get(arg);
    };
};
export var memoizeStyle = function (styles) {
    Object.keys(styles).forEach(function (className) { return (styles[className] = memoize(styles[className])); });
    return styles;
};
export var cssName = function (className) { return "." + className; };
